import { Buttons, FlexContainer, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { showChat } from 'Services/chat';
import useTranslation from 'Hooks/useTranslation';
import * as Styled from 'Containers/Dashboard/components/TaxScreen/components/styles';
import { lottiesPaths } from 'Constants/lottiesPaths';
import { TaxScreenType } from 'Types/common';

const WaitingChanges = ({ tax }: TaxScreenType): JSX.Element => {
  const { t } = useTranslation(locizeNS.DASHBOARD);
  const { taxYear } = tax;
  return (
    <FlexContainer fullWidth fullHeight direction="column" gap="dimension_16" justify="center">
      <Styled.InfoContainer justify="center" direction="column" align="center" gap="dimension_08">
        <Text size="L_L_S" color="dark" type="headline">
          {taxYear}
        </Text>
        <Text type="paragraphs" size="L_L_M" color="dark" align="center">
          {t('Dashboard.WaitingChanges.message')}
        </Text>
        <Styled.StyledLottie
          options={{ path: lottiesPaths.MORE_INFO, rendererSetting: { progressiveLoad: true } }}
        />
        <Text type="paragraphs" color="dark" size="M_L_S" align="center">
          {t('Dashboard.WaitingChanges.description')}
        </Text>
        <Text type="paragraphs" color="dark" size="S_S_S" align="center">
          {t('Dashboard.WaitingChanges.info')}
        </Text>
        <Styled.ButtonsWrapper direction="column" fullWidth gap="dimension_16" align="center">
          <Styled.MultipleButtonContainer
            direction="row-reverse"
            gap="dimension_16"
            justify="center"
            fullWidth
          >
            <Buttons.Classic
              size="m"
              mode="primary"
              label={t('Dashboard.WaitingChanges.button')}
              onClick={showChat}
            />
          </Styled.MultipleButtonContainer>
        </Styled.ButtonsWrapper>
      </Styled.InfoContainer>
    </FlexContainer>
  );
};

export default WaitingChanges;
